import React from 'react';
import {useDispatch} from 'react-redux';
import {Col, UiBox} from '~/components/elements';
import {DOB_KEY, POP_UP_PH_CHECKOUT_KEYS} from '~/constants/popup';
import {Swiper, SwiperSlide} from 'swiper/react';
import {Pagination} from 'swiper';
import {PopupDOB, PopupFour, PopupOne, PopupThree, PopupTwo} from '~/pages/homes/pop-up';
import {setPopupNextSlideKey} from '~/redux/questionnaires/slice';
import 'swiper/swiper.min.css';
import 'swiper/swiper-bundle.css';

const POPUP_CPN = [PopupDOB, PopupOne, PopupTwo, PopupThree, PopupFour];

export const BCPHCheckoutPopup = () => {
  const dispatch = useDispatch();

  return (
    <UiBox style={{backgroundColor: 'white'}}>
      <Swiper
        modules={[Pagination]}
        spaceBetween={30}
        style={{backgroundColor: 'white', width: '95vw', height: '100vh'}}
        pagination={{clickable: false}}
        onSwiper={swiper => {
          if (swiper.activeIndex === 0) {
            swiper.disable();
          }
        }}
        onSlideChange={swiper => {
          if (swiper.activeIndex > 0) {
            dispatch(setPopupNextSlideKey(Object.values(POP_UP_PH_CHECKOUT_KEYS)[swiper.activeIndex]));
          } else {
            dispatch(setPopupNextSlideKey(DOB_KEY));
          }
        }}
        shortSwipes={false}
      >
        {POPUP_CPN.map((cpn, idx) => {
          const PopupCpn = cpn;
          return (
            <SwiperSlide key={idx}>
              <Col w="100%" h="100%">
                <PopupCpn />
              </Col>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </UiBox>
  );
};
